module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Unfold Software Development","short_name":"Unfold","start_url":"/","background_color":"#000","theme_color":"#000","display":"minimal-ui","icon":"src/images/unfold_icon.png"},
    }]
